import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import BirthChartForm from "@/pages/BirthChartForm";
import BirthChartReading from "@/pages/BirthChartReading";
import CompatibilityForm from "@/pages/CompatibilityForm";
import CompatibilityReading from "@/pages/CompatibilityReading";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import AdsPage from "@/pages/AdsPage";
import TestimonialPage from "@/pages/TestimonialPage";
import AdminTestimonialsPage from "@/pages/AdminTestimonialsPage";
import MyReadingsPage from "@/pages/MyReadingsPage";
import SubscribePage, { SubscriptionSuccessPage, SubscriptionManagePage } from "@/pages/Subscribe";
import ReferralPage from "@/pages/ReferralPage";
import CookieBanner from "@/components/earthpulse/CookieBanner";
import InstallPrompt from "@/components/earthpulse/InstallPrompt";
import PWAWelcome from "@/components/earthpulse/PWAWelcome";
import CosmicScoreNudge from "@/components/earthpulse/CosmicScoreNudge";
import MoonMilestoneToast from "@/components/earthpulse/MoonMilestoneToast";
import { Toaster } from "@/components/ui/sonner";
import { initTracking, trackPageView } from "@/lib/tracking";

function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    initTracking();
    trackPageView();
    // Scroll to top on every route change so long landing sections don't
    // strand people mid-page when they click a nav link.
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsListener />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/almanac" element={<Dashboard />} />
          <Route path="/birth-chart" element={<BirthChartForm />} />
          <Route path="/birth-chart/reading" element={<BirthChartReading />} />
          <Route path="/compatibility" element={<CompatibilityForm />} />
          <Route path="/compatibility/reading" element={<CompatibilityReading />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/ads" element={<AdsPage />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/subscription" element={<SubscriptionManagePage />} />
          <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
          <Route path="/testimonial" element={<TestimonialPage />} />
          <Route path="/admin/testimonials" element={<AdminTestimonialsPage />} />
          <Route path="/my-readings" element={<MyReadingsPage />} />
          <Route path="/friend/:code" element={<ReferralPage />} />
        </Routes>
        <CookieBanner />
        <InstallPrompt />
        <PWAWelcome />
        <CosmicScoreNudge />
        <MoonMilestoneToast />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
